import { getAuth } from 'firebase/auth';

const onceAuthResolved = (store, fn) => {
  if (store.state.auth.resolved) return Promise.resolve(fn());

  return new Promise((resolve) => {
    const unwatch = store.watch(
      (state) => state.auth.resolved,
      () => {
        unwatch();
        resolve(fn());
      },
    );
  });
};

export default async ({ router, store }) => {
  router.beforeEach(async (to, from, next) => {
    store.dispatch('auth/request');

    try {
      await onceAuthResolved(store, async () => {
        const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
        const { currentUser } = getAuth();

        if (currentUser) {
          const { claims } = await currentUser.getIdTokenResult();
          if (claims.superAdmin || claims.eyeStaff) {
            if (['/admin/devices'].includes(to.path)) {
              next({
                path: '/admin/organisations',
              });
              return;
            }
          }
          if (claims.orgAdmin) {
            if (['/admin/organisations'].includes(to.path)) {
              next({
                path: '/admin/users',
              });
              return;
            }
          }
          if (!claims.superAdmin && !claims.eyeStaff && !claims.orgAdmin) {
            if (['/admin/organisations', '/admin/users'].includes(to.path)) {
              next({
                path: '/admin/devices',
              });
              return;
            }
          }
        }

        if (requiresAuth && !currentUser) next('/login');
        else if (!requiresAuth && currentUser) next('/');
        else next();
      });
    } catch (error) {
      console.error('Navigation guard error:', error);
      next('/login');
    }
  });
};
